<template>
  <component class="Header" :class="className" :is="tagName">
    <slot></slot>
  </component>
</template>

<script>
import cx from "classnames";

export default {
  name: "Header",
  props: {
    h1: Boolean,
    h2: Boolean,
    gradient: Boolean,
    grey: Boolean,
    first: Boolean
  },
  computed: {
    tagName() {
      if (this.h1) {
        return "h1";
      } else if (this.h2) {
        return "h2";
      } else {
        return "h1";
      }
    },
    className() {
      return cx({
        first: this.first,
        gradient: this.gradient,
        grey: this.grey
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.Header {
  font-family: $font-alt;
  letter-spacing: 0.05em;
  color: $c-green;

  &.first {
    margin-top: 0;
  }

  &.gradient {
    background: -webkit-linear-gradient(left, $c-green_2, $c-blue);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &.grey {
    color: #717171;
  }
}
</style>
